var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    "data-name": "016_FOOD",
    id: "_016_FOOD",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#333;}")), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.44,17H15.59a1,1,0,0,1,0-2h4.72c-.6-2.18-3.18-3-5-3s-4.37.82-5,3h1.24a1,1,0,0,1,0,2H9.22a1,1,0,0,1-1-1c0-3.94,3.58-6,7.11-6s7.11,2.06,7.11,6A1,1,0,0,1,21.44,17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.11,22H12.56a4.34,4.34,0,0,1-4.34-4.33V15.44a1,1,0,0,1,2,0v2.23A2.34,2.34,0,0,0,12.56,20h5.55a2.34,2.34,0,0,0,2-1.17,1,1,0,0,1,1.74,1A4.37,4.37,0,0,1,18.11,22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,22H5a1,1,0,0,1-1-.87l-2-15a1,1,0,0,1,.24-.79A1,1,0,0,1,3,5H14a1,1,0,0,1,.76.34,1,1,0,0,1,.23.8l-.29,2A1,1,0,0,1,13.57,9a1,1,0,0,1-.85-1.13L12.85,7H4.14L5.88,20H12a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9,7A1,1,0,0,1,8,6V3.41l-.71-.7A1,1,0,1,1,8.71,1.29l1,1A1,1,0,0,1,10,3V6A1,1,0,0,1,9,7Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWc);
export default __webpack_public_path__ + "static/media/wc.991a5b8854a3d3134ee5a8e6eae09ae2.svg";
export { ForwardRef as ReactComponent };